var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcOutlet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.575,
    height: 9.575,
    viewBox: "0 0 9.575 9.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1869.529,2092a4.787,4.787,0,1,0,4.787,4.787A4.787,4.787,0,0,0,1869.529,2092Zm-.95,4.018h-2.436v-.85h2.436Zm1.578,3.841h-1.475v-1.437a.738.738,0,0,1,.738-.738h0a.737.737,0,0,1,.737.738Zm2.519-3.841h-1.59v.668h-.85v-1.267h0v-.251h2.436Z",
    transform: "translate(-1864.741 -2091.997)",
    fill: "#3d3d3d"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlet2);
export default __webpack_public_path__ + "static/media/ic-outlet-2.25ceafad24c418049592cb9d54f0caa8.svg";
export { ForwardRef as ReactComponent };